import { Box } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RightMenuProvider } from "./components/Layout"; // circular dependency when imported earlier
import { AuthProvider } from "./features/Authorization/AuthProvider";
import { GamificationProvider } from "./features/Gamification/GamificationProvider";
import { GlobalLoader } from "./features/GlobalLoader/GlobalLoader";
import { I18nProvider, TLIntlProvider } from "./features/I18n/I18nProvider";
import { ModalProvider } from "./features/Modal/ModalProvider";
import { SnackbarProvider } from "./features/Snackbar/SnackbarProvider";
import { VisualEffectsProvider } from "./features/VisualEffects/VisualEffectsProvider";
import "./index.css";
import theme from "./theme";

const queryClient = new QueryClient();
if (!window._queryClient) window._queryClient = queryClient;

export const Contexts = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <VisualEffectsProvider>
        <TLIntlProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <GlobalLoader>
                <SnackbarProvider>
                  <I18nProvider>
                    <ModalProvider>
                      <GamificationProvider>
                        <RightMenuProvider>
                          <CssBaseline />
                          {children}
                        </RightMenuProvider>
                      </GamificationProvider>
                    </ModalProvider>
                  </I18nProvider>
                </SnackbarProvider>
              </GlobalLoader>
            </AuthProvider>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: 0,
                height: 0,
              }}
            >
              <ReactQueryDevtools initialIsOpen={false} />
            </Box>
          </QueryClientProvider>
        </TLIntlProvider>
      </VisualEffectsProvider>
    </ThemeProvider>
  );
};
